export function SkipLink() {
  return <a className="skip-link" href="#main-content">Skip to content</a>;
}
